import Icon from '../components/Icon.vue'

Icon.register({"power-off":{"width":512,"height":512,"paths":[{"d":"M400 54.1C463 99.1 504 172.7 504 256 504 392.8 393.2 503.7 256.5 504 120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2 123.5 45.9 139.8 49.4 146.8 61.9L162.6 90C168.5 100.5 165.7 113.8 156 121 114.5 151.8 88 200.6 88 255.9 87.9 348.2 162.5 424 256 424 347.6 424 424.6 349.8 424 254.9 423.7 203.1 399.3 153.1 355.9 120.9 346.2 113.7 343.5 100.4 349.4 90L365.2 61.9C372.2 49.5 388.4 45.8 400 54.1zM296 264V24C296 10.7 285.3 0 272 0H240C226.7 0 216 10.7 216 24V264C216 277.3 226.7 288 240 288H272C285.3 288 296 277.3 296 264z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/power-off.js
// module id = null
// module chunks = 